import { createContext, useContext, useState } from 'react'

// Crear el contexto
const PlanificacionesContext = createContext(null)

// Hook personalizado para usar el contexto
export const usePlanificaciones = () => {
  const context = useContext(PlanificacionesContext)
  if (!context) {
    throw new Error('usePlanificaciones debe usarse dentro de PlanificacionesProvider')
  }
  return context
}

// Provider component
export const PlanificacionesProvider = ({ children }) => {
  // Estado: qué vista mostrar ('dashboard' | 'form' | 'gantt' )
  const [currentView, setCurrentView] = useState('dashboard')

  // Estado: planificación seleccionada (para editar o ver gantt)
  const [selectedPlanificacion, setSelectedPlanificacion] = useState(null)

  // Estado: modo del formulario ('create' | 'edit')
  const [formMode, setFormMode] = useState(null)

  // Estado: trigger para refetch de datos
  const [refreshTrigger, setRefreshTrigger] = useState(0)

  // Estado: status de la planificación activa (para saber qué tabs mostrar)
  const [planificacionStatus, setPlanificacionStatus] = useState(null)

  // FUNCIONES DE NAVEGACIÒN

  // Ir al dashboard
  const goToDashboard = () => {
    setCurrentView('dashboard')
    setSelectedPlanificacion(null)
    setFormMode(null)
    setPlanificacionStatus(null)
  }

  // Ir a crear nueva planificación
  const goToCreate = () => {
    setCurrentView('form')
    setFormMode('create')
    setSelectedPlanificacion(null)
    setPlanificacionStatus(null)
  }

  // Ir a editar planificación existente
  const goToEdit = (planificacion) => {
    setCurrentView('form')
    setFormMode('edit')
    setSelectedPlanificacion(planificacion)
  }

  // Ir a ver Gantt de planificación
  const goToGantt = (planificacion) => {
    setCurrentView('gantt')
    setSelectedPlanificacion(planificacion)
  }

  // Forzar refresh de datos (después de guardar/eliminar)
  const triggerRefresh = () => {
    setRefreshTrigger((prev) => prev + 1)
  }

  // Actualizar el status de la planificación activa
  const updatePlanificacionStatus = (status) => {
    setPlanificacionStatus(status)
  }

  // Valor del contexto (lo que compartimos con todos los componentes)
  const value = {
    // Estado
    currentView,
    selectedPlanificacion,
    formMode,
    refreshTrigger,
    planificacionStatus,

    // Funciones de navegación
    goToDashboard,
    goToCreate,
    goToEdit,
    goToGantt,
    triggerRefresh,
    updatePlanificacionStatus,
  }

  return <PlanificacionesContext.Provider value={value}>{children}</PlanificacionesContext.Provider>
}
